import React, { FC } from 'react'
import {
  WorkspaceNameText,
  HelpText,
} from './WorkspaceAccessLevelDropdown.styles'
import { ShareForSettingsModal } from '../types'
import Box, { Flex } from 'components/Box'
import Spinner from 'components/Spinner'
import {
  AccessLevelSelect,
  DropdownTitle,
  WorkspaceAccessLevelType,
} from '../AccessLevelSelect'
import WorkspaceLogo from 'modules/workspace/components/WorkspaceLogo'
interface WorkspaceAccessLevelDropdownProps {
  share: Pick<
    ShareForSettingsModal,
    'allowedWorkspaceAccessLevels' | 'isDraft' | 'workspace'
  >
  commentsEnabled: boolean
  setCommentsEnabled: (value: boolean) => void
  loading: boolean
  level: WorkspaceAccessLevelType
  setLevel: (value: WorkspaceAccessLevelType) => void
  workspaceMembersCount?: number
}

const getHelpText = (workspaceMembersCount: number | undefined) => {
  if (workspaceMembersCount === undefined) {
    return `Loading…`
  }

  if (workspaceMembersCount === 1) {
    return `${workspaceMembersCount} Workspace Member`
  }

  return `${workspaceMembersCount} Workspace Members`
}

const WorkspaceAccessLevelDropdown: FC<WorkspaceAccessLevelDropdownProps> = ({
  share,
  level,
  setCommentsEnabled,
  commentsEnabled,
  setLevel,
  loading,
  workspaceMembersCount,
}) => {
  const helpText = share.isDraft
    ? 'Cannot access the document.'
    : getHelpText(workspaceMembersCount)

  // We should already have a workspace once we reach this place
  const workspace = share.workspace!

  return (
    <Flex alignItems="flex-start">
      <Box UNSAFE_mt={'2px'}>
        <WorkspaceLogo
          src={workspace.avatar?.small}
          workspaceName={workspace.name}
          size="32px"
        />
      </Box>
      <Box ml={2} mr={2}>
        <WorkspaceNameText>{workspace.name}</WorkspaceNameText>
        <HelpText>{helpText}</HelpText>
      </Box>
      <Flex ml="auto">
        {loading && <Spinner.Flex mr={2} primary />}
        <Box UNSAFE_ml={loading ? 0 : '30px'} UNSAFE_mt={'3px'}>
          {share.isDraft ? (
            <DropdownTitle disabled>No Access</DropdownTitle>
          ) : (
            <AccessLevelSelect
              access={{
                kind: 'workspace',
                level,
                setLevel,
                allowedLevels: share.allowedWorkspaceAccessLevels,
              }}
              commentsEnabled={commentsEnabled}
              setCommentsEnabled={setCommentsEnabled}
              canUpdateCommentsEnabled={level !== 'DEFAULT'}
            />
          )}
        </Box>
      </Flex>
    </Flex>
  )
}

export { WorkspaceAccessLevelDropdown }
